import axios from 'axios';
import { API_URI } from '../config/index.jsx';

declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    gtag?: (...args: any[]) => void;
  }
}

export const generateEventId = () =>
  `${Date.now()}-${Math.random().toString(36).slice(2)}`;

export const readCookie = (name: string): string | undefined => {
  if (typeof document === 'undefined') return undefined;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : undefined;
};

type TrackableEvent = 'PageView' | 'CTA_Click';

export const trackEvent = (
  eventName: TrackableEvent,
  opts: { custom?: boolean } = {},
) => {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;

  const eventId = generateEventId();
  const method = opts.custom === false ? 'track' : 'trackCustom';

  window.fbq(method, eventName, {}, { eventID: eventId });

  axios
    .post(
      `${API_URI}/api/medical/track/`,
      {
        event_name: eventName,
        event_id: eventId,
        event_source_url: window.location.href,
        fbp: readCookie('_fbp'),
        fbc: readCookie('_fbc'),
      },
      { withCredentials: true },
    )
    .catch(() => undefined);
};
